import angular from 'angular';
import SubscriptionCancelModal from './subscriptionCancelModal';

export default angular
  .module('components.subscriptionCancelModal', [])
  .component('subscriptionCancelModal', SubscriptionCancelModal).name;
